<template>
  <div class="main">
    <div class="main-title">第三方平台</div>
    <div class="main-top">
      <third></third>
    </div>
  </div>
</template>

<script>
import Third from "./components/third.vue";

export default {
  components: {
    Third
  },
  data() {
    return {};
  },
  methods: {
    queryData() {
      const that = this;
      that.$get(
        `${this.$store.state.api.webUrl}/navigation/getSearchData.json`,
        {
          province: '河北省',
          city: '石家庄市',
        },
        (data) => {
          if (data) {
            that.$store.commit(
              "dealcenter/updateactiveName",
              "third"
            );
            that.$store.commit("dealcenter/updateData", data);
          }
        }
      );
    },
  },
  created() {
    this.$store.dispatch("analysis/updateHits", {
      visitlocation: "第三方平台",
    });
    this.queryData();
  }
};
</script>

<style scoped lang="scss">
@import "@css/var.scss";

.main {
  width: 1200px;

  .main-title {
    font-size: 16px;
    font-weight: bold;
    position: absolute;
    left: 20px;
    top: 10px;
    z-index: 100;
  }

  .main-top {
    background-color: white;
    overflow: hidden;
    padding: 40px 0 45px 40px;
    min-height: 500px;
  }
}
</style>
